import { render, staticRenderFns } from "./DispenserVariant.vue?vue&type=template&id=0b000448&scoped=true&"
import script from "./DispenserVariant.vue?vue&type=script&lang=js&"
export * from "./DispenserVariant.vue?vue&type=script&lang=js&"
import style0 from "./DispenserVariant.vue?vue&type=style&index=0&id=0b000448&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b000448",
  null
  
)

export default component.exports